function toCamelCase<T>(str: string): T {
  return str.replace(/\s+/g, '').replace(/(?:^\w|[A-Z]|\b\w)/g, (match, index) => {
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  }) as T;
}

export { toCamelCase };
